import React from "react";

type ImgProps = React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
> &
    Partial<{
        className: string;
        src: string;
        alt: string;
    }>;

const Img: React.FC<React.PropsWithChildren<ImgProps>> = ({
                                                              className,
                                                              src = "",
                                                              alt = "",
                                                              ...restProps
                                                          }) => {
    return (
        <img
            className={className}
            src={src}
            alt={alt}
            {...restProps}
            loading="lazy"
        />
    );
};

export {Img};
